import React from 'react';
import {
  Button,
  Copy,
  Flex,
  Square,
  Stack,
  SvgDownload,
} from '@grubhubprod/gh-cookbook-react';

interface DownloadCardProps {
  title: string;
  description: string;
  actionLabel: string;
  onClick: () => void;
  isDisabled: boolean;
  isLoading: boolean;
}

export function DownloadCard({
  title,
  description,
  actionLabel,
  onClick,
  isDisabled,
  isLoading,
}: DownloadCardProps): JSX.Element {
  return (
    <Square bg="backgroundTint" borderRadius="medium" height="100%" inset="md">
      <Stack y="xxx-sm">
        <Copy variant="smallButton" textAlign="left">
          {title}
        </Copy>
      </Stack>
      <Stack y="sm">
        <Copy variant="body" textAlign="left">
          {description}
        </Copy>
      </Stack>
      <Button
        variant="secondary"
        type="button"
        buttonSize="small"
        disabled={isDisabled}
        onClick={onClick}
        isLoading={isLoading}
      >
        <Flex alignItems="center">
          <Stack x="x-sm">
            <SvgDownload />
          </Stack>
          <Copy variant="smallButton" color="inherit">
            {actionLabel}
          </Copy>
        </Flex>
      </Button>
    </Square>
  );
}
